import * as React from 'react'
import { memo } from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import { uniformUrl } from '../../helpers/StringHelpers'
import { Helmet } from 'react-helmet'

export const getFinalBreadcrumbs = (breadcrumbs, title, location, origin, canonical) => {
  const clean = Array.isArray(breadcrumbs)
    ? breadcrumbs.map(m => {
      return { url: m.url, name: m.name }
    })
    : []
  if (title) {
    if (canonical) {
      clean.push({ url: canonical, name: title })
    } else if (location) {
      clean.push({ url: location.replace(origin, ''), name: title })
    }
  }
  return clean
}

const BreadcrumbsComponent = ({ breadcrumbs, title, location, origin, canonical, className }) => {
  const query = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const siteUrl = query.site.siteMetadata.siteUrl
  if(!origin) {
    origin = siteUrl
  }
  const clean = getFinalBreadcrumbs(breadcrumbs, title, location, origin, canonical)
  const JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    name: 'Breadcrumbs',
    itemListOrder: 'https://schema.org/ItemListOrderAscending',
    numberOfItems: `${clean.length + 1}`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': `${origin}/`,
          name: 'Gray & Sons Jewelers',
        },
      },
      ...clean.map(({ name, url }, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        item: {
          '@id': uniformUrl(url, origin),
          name: name,
        },
      })),
    ],
  }
  return (
    <React.Fragment>
      <nav
        className={
          className ||
          'md:w-10/12 px-5 lg:px-0 text-md mx-auto flex space-x-2 overflow-auto items-center p-1 text-gray-600 max-w-[1366px] relative pb-2 '
        }
      >
        <Link to={'/'} className={'text-md text-gray-600 my-auto'}>
          Home
        </Link>
        {clean.map(({ url, name }) => {
          return (
            <React.Fragment key={url}>
              <Link
                to={url}
                className={
                  'text-sm border border-gray-300 py-1 px-2 whitespace-nowrap text-gray-600 hover:text-black hover:border-black duration-150 flex-shrink ease-in md:last:text-ellipsis md:text-ellipsis md:overflow-visible md:last:overflow-hidden'
                }
              >
                {name}
              </Link>
            </React.Fragment>
          )
        })}

        {/* <div className="fixed px-12 right-0 bg-gradient-to-r from-transparent to-white h-8"> </div> */}
      </nav>
      <Helmet>
        <script type="application/ld+json" id='breadcrumbs'>{JSON.stringify(JSON_LD)}</script>
      </Helmet>
    </React.Fragment>
  )
}

const Breadcrumbs = memo(BreadcrumbsComponent)

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  ]),
  canonical: PropTypes.string,
  location: PropTypes.string,
  title: PropTypes.string,
  origin: PropTypes.string,
  className: PropTypes.string,
}

Breadcrumbs.defaultProps = {
  breadcrumbs: false,
  canonical: null,
  location: null,
  title: null,
  origin: null,
  className: null,
}

BreadcrumbsComponent.propTypes = {
  breadcrumbs: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  ]),
  canonical: PropTypes.string,
  location: PropTypes.string,
  title: PropTypes.string,
  origin: PropTypes.string,
  className: PropTypes.string,
}

export default Breadcrumbs
